import React from "react";
import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n";

const Message = () => {
    const { t } = useTranslation();

    return (
        <section id="message" className="py-16">
            <AnimatedSection>
                <div className="container mx-auto flex flex-col lg:flex-row items-start px-6 lg:px-20">
                    {/* Text Content */}
                    <div className="w-full p-4">
                        <h2 className="text-3xl font-bold mb-8">
                            {t("message:message.title")}
                        </h2>

                        {/* Centered Circular Image */}
                        <img
                            src="/images/others/CEOimage.svg"
                            alt="CEO Portrait"
                            className="w-40 h-40 rounded-full object-cover mx-auto mb-8 shadow-md"
                        />

                        <p className="text-lg text-justify mb-4">
                            {t("message:message.paragraph1")}
                        </p>

                        <p className="text-lg text-justify mb-4">
                            {t("message:message.paragraph2")}
                        </p>

                        <p className="text-lg text-justify mb-4">
                            {t("message:message.paragraph3")}
                        </p>

                        <p className="text-lg text-justify">
                            {t("message:message.paragraph4")}
                        </p>

                        <div className="mt-8 space-y-1">
                            <p className="text-xl font-semibold">{t("message:affiliation.name")}</p>
                            <p className="text-lg">{t("message:affiliation.designation")}</p>
                            <p className="text-lg">{t("message:affiliation.companyName")}</p>
                        </div>
                    </div>

                    {/* Image Section */}
                    {/* <div className="lg:w-1/3 flex justify-center mt-6 lg:mt-0">
                        <img 
                            src="/images/others/CEOimage.svg" 
                            alt="CEO Portrait" 
                            className="w-full max-w-md rounded-lg shadow-lg object-cover" 
                        />
                    </div> */}
                </div>
            </AnimatedSection>
        </section>
    );
};

export default Message;